import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { ConfigurationValue } from '@app/orgs/configuration-value';
import { OrgSettingsService } from '@app/orgs/services/org-settings.service';
import { OrgSetting } from '@app/orgs/services/orgs';
import { AuthService } from '@app/shared/services/auth.service';

/**
 * Resume Parsing Base route guard to control the accessibility for ops tool setting
 * `disableResumeParsingInOnboarding`
 */
@Injectable({
  providedIn: 'root',
})
export class OnboardingRequiredGuard implements CanActivate {
  public isAuthorized: boolean = false;
  protected redirectTo = '/getstarted/welcome';

  constructor(
    protected authService: AuthService,
    private orgSettingService: OrgSettingsService,
    protected router: Router
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> {
    if (!this.authService.isLoggedIn) {
      return of(true);
    }
    if (!state?.url) {
      return of(true);
    }
    if (state.url.includes('/getstarted') || state.url.includes('/faq/')) {
      return of(true);
    }
    if (this.authService.authUser.defaultOrgInfo) {
      return this.orgSettingService
        .getOrgSettings(
          this.authService.authUser.defaultOrgId,
          ConfigurationValue.OrgCommunications
        )
        .pipe(
          map((orgSettings: OrgSetting[]) => {
            const setting: OrgSetting = orgSettings.find(
              (setting) => setting.id === 'WelcomeIntro'
            );
            if (
              setting?.value &&
              !this.authService.authUser.viewerProfile.introCompleted
            ) {
              // this.router.navigateByUrl(this.redirectTo);
              this.redirectToOnboarding();
              return false;
            }
            return true;
          })
        );
    } else {
      if (!this.authService.authUser.viewerProfile.introCompleted) {
        // See above comment
        // return this.router.navigateByUrl(this.redirectTo);
        this.redirectToOnboarding();
      }
      return of(true);
    }
  }

  protected redirectToOnboarding() {
    // This fixes a bug (https://degreedjira.atlassian.net/browse/PD-87714)
    // It should be considered a bandaid and once we've gottern further with
    // cleaning up module imports, and cshtml pages, this hack shouldn't be necessary
    (window as any).location = this.redirectTo;
  }
}
